<div class="llm-wrapper d-flex flex-row w-100">
  <div class="llm-sidenav overflow-auto">
    <app-side-panel-view
      [projectId]="dataStore.data?.id"
      (onLoadVersions)="loadAllVersions()"
    ></app-side-panel-view>
  </div>
  <div class="lln-content d-flex flex-column h-100">
    <div class="content-head">
      <span class="header-13">Generated Projects</span>
    </div>
    <div class="content-body overflow-auto">
      @if(isLoading) {
      <app-loading
        class="h-100 loading-container"
        [text]="'Loading'"
      ></app-loading>
      } @else {
      <div
        class="row row-cols-1 row-cols-md-3 pb-3 flex-grow-1 overflow-auto mb-3"
      >
        @for(item of cards; track trackItem) {
        <div class="card-wrapper mt-3">
          <app-test-caes-panel-view
            [data]="item"
            (onEventEmit)="handleCardAction($event)"
          ></app-test-caes-panel-view>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
